import React from 'react';

// Guards a Google Map: Maps can fail to initialise (referer/quota/outage) and the
// <Marker> children throw during render — without a boundary that would unmount the
// whole page (the map is a sibling of real content). Here it degrades to an optional
// `fallback` instead, keeping the rest of the page alive. Shared by the co-living
// deal detail (inspector map) and the co-living feed (LeadsMap).
class MapErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: false };
    }
    static getDerivedStateFromError() {
        return { failed: true };
    }
    componentDidCatch() { /* map is non-critical chrome — swallow and show fallback */ }
    render() {
        if (this.state.failed) return this.props.fallback || null;
        return this.props.children;
    }
}

export default MapErrorBoundary;
